/**
 * @generated SignedSource<<138238bf08ff12610c67c9c231c87b2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goals_nativeIssueTable_GoalsCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "goals_nativeIssueTable_GoalsCell";
};
export type goals_nativeIssueTable_GoalsCell$key = {
  readonly " $data"?: goals_nativeIssueTable_GoalsCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"goals_nativeIssueTable_GoalsCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "goals_nativeIssueTable_GoalsCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraGoalsField"
};

(node as any).hash = "c06d2cf0d8aec11ffdbf49b380c6dd10";

export default node;
